import React, { useEffect } from 'react';
import { Container, Typography, Box, Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import MenuAppBar from '../components/MenuAppBar';
import MenuBottAppBar from '../components/MenuBottAppBar';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
//import axios from "axios";

const Energie = () => {
  //const { logout, role } = useContext(AuthContext);
  const navigate = useNavigate();
  //const [aplikace, setAplikace] = useState([]);

  /*const bull = (
    <Box
      component="span"
      sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
    >
      •
    </Box>
  );
  const card = (
    <React.Fragment>
      <CardContent>
        <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
          Word of the Day
        </Typography>
        <Typography variant="h5" component="div">
          be{bull}nev{bull}o{bull}lent
        </Typography>
        <Typography sx={{ color: 'text.secondary', mb: 1.5 }}>adjective</Typography>
        <Typography variant="body2">
          well meaning and kindly.
          <br />
          {'"a benevolent smile"'}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small">Learn More</Button>
      </CardActions>
    </React.Fragment>
  );*/

  /*
  const handleLogout = () => {
    logout();
    navigate('/');
  };
  */
/*
  const getAuthHeaders = () => {
    const token = localStorage.getItem("accessToken");
    return { Authorization: `Bearer ${token}` };
  };
*/
  useEffect(() => {
    const fetchData = async () => {
      /*try {
        const response = await fetch("https://api.example.com/data");
        const result = await response.json();
        setData(result); // Uložení dat do stavu
      } catch (error) {
        console.error("Chyba při načítání dat:", error);
      }*/
      //const data0 = await axios.get("/api/apps", { headers: getAuthHeaders(), params:{}});
      //setAplikace(data0.data);

    };

    fetchData();
    document.title = 'Dashboard - Energie';
    
  }, []);
  
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }));

  return (
    
    <Container>
      
      <MenuAppBar title='Dashboard' />
      
      <Box sx={{ flexGrow: 1 }} mt={1}>
      <Grid container spacing={2}>

      <Grid size={2}>
        <Item>
          <Card variant="outlined" style={{cursor: 'pointer'}} onClick={() => navigate("/Dashboard")}>
          <CardContent>
            <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
              Home
            </Typography>
            <Typography variant="h5" component="div">
              Dashboard
            </Typography>
          </CardContent>
          </Card>
        </Item>
      </Grid>  
        
      <Grid size={4}>
        <Item>
          <Card variant="outlined" style={{cursor: 'pointer'}} onClick={() => navigate("/EnergieEntitaGrafRok")}>
          <CardContent>
            <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
              Grafy
            </Typography>
            <Typography variant="h5" component="div">
              Spotřeba rok
            </Typography>
          </CardContent>
          </Card>
        </Item>
      </Grid>
        
      <Grid size={2}>
        <Item>
          <Card variant="outlined" style={{cursor: 'pointer'}} onClick={() => navigate("/EnergieDataObdEntity")}>
          <CardContent>
            <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
              Data
            </Typography>
            <Typography variant="h5" component="div">
              Entity
            </Typography>
          </CardContent>
          </Card>
        </Item>
      </Grid>  

      <Grid size={2}>
        <Item>
          <Card variant="outlined" style={{cursor: 'pointer'}} onClick={() => navigate("/EnergieDataDenEntity")}>
          <CardContent>
            <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
              Data Den
            </Typography>
            <Typography variant="h5" component="div">
              Entity
            </Typography>
          </CardContent>
          </Card>
        </Item>
      </Grid>  
        
      </Grid>
      </Box>
      <MenuBottAppBar value={'Energie'} />
    </Container>
       
  );
};

export default Energie;
